module.exports = __webpack_public_path__ + "img/1440.4ba58fb2.jpg";